import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-players/$tag/search-filters/global")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/my-players/$tag/clan-search/filters",
      params,
    });
  },
});
